import React from 'react'
import "./Feb.css"

function Febosat() {
  return (
    <div>
       {/* <!-- Start Hero --> */}
    <section class="common-page-hero">
        <img src="assets/img/bg/bgf.png" class="common-hero-bg ak-bg" alt="..." />
        <div class="common-hero-content">
            <div class="common-hero-info">
                <div class="ak-section-heading ak-style-1 animation-title-content animation-style3">
                    <p class="ak-section-subtitle animation-title" style={{color:'white'}}> Courses</p>
                    <h2 class="ak-section-title animation-title" style={{fontSize:'45px',color:'white'}}>
                    SEMANTIC Skills Junction: Bridging Talent and Technology
                    </h2>
                </div>
                <p class="back-btn" style={{color:'white'}}><a href="/">Home</a> / Course</p>
            </div>
            <a href="" class="phone-number" style={{color:'white'}}>(+91) 7619617023</a>
        </div>
    </section>
    {/* <!-- End Hero --> */}
    {/* <!-- Start Service --> */}
   
     {/* <div class="ak-height-75 ak-height-lg-50"></div> */}
    <section>
        <div class="container" style={{marginTop:"20px"}}>
            <div class="ak-section-heading ak-style-1 animation-title-content animation-style3">
                <h3 class="ak-section-title animation-title" style={{fontSize:'40px'}}>
                Integrated Wafer Fab And OSAT Finishing School

                </h3>
                <p class="ak-section-desp" style={{textAlign:'justify'}}>
               
      Shape your future in semiconductor manufacturing with our <strong>Integrated Wafer Fab & OSAT Finishing School</strong>. This comprehensive program equips participants with the skills needed to excel in wafer fabrication, assembly, and testing operations.
      Our Integrated Wafer Fab & OSAT Finishing School offers a unique and comprehensive program designed to prepare individuals for high-demand roles in semiconductor manufacturing, assembly, and testing. With a focus on practical skills and corporate-specific customization, this program is tailored to meet the needs of both 
        individuals and organizations seeking excellence in the semiconductor industry.</p>


              
            </div>
            <div class="ak-height-50 ak-height-lg-30"></div>
            {/* <!-- Start Images --> */}
            {/* <div class="content-image-container" style={{display: "flex"}}> */}
    {/* <div class="image-hov-one" style={{flex: "1"}}>
        <img class="img-fluid" src="assets/img/service/c1.png" alt="..." />
    </div>
    <div class="text-content" style={{flex: "1",marginLeft:'60px'}}>
        <p style={{margin: "0"}}>
            It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. 
            The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, 
            content here', making it look like readable English. It is a long established fact that a reader will be distracted by the 
            readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less 
            normal distribution.
        </p>
    </div> */}
{/* </div> */}
            {/* <div class="image-hov-one" >
                <img class="img-fluid" src="assets/img/service/m1.png" alt="..."  style={{marginRight:"20px"}}/>
                
            </div> */}
            {/* <div class="ak-height-50 ak-height-lg-30"></div> */}
            <p>
            
            </p>
            {/* <!-- End Images --> */}
        </div>
    </section>
    {/* <!-- End Service Details --> */}
  

  <section>
  <div className="container" style={{ marginTop: '20px' }}>
   
    <section className="wafer-fab-section">
      <div className="wafer-container">
        <div className="program-header">
          <h2 className="program-title">INTEGRATED WAFER FAB + OSAT FINISHING SCHOOL</h2>
          <p className="program-subtitle">** CAN BE OFFERED UPON REQUEST</p>
        </div>

        <div className="features-container" style={{ padding: '0px', backgroundColor: 'rgb(255, 240, 234)' }}>
          <div className="feature-item">
            <div className="feature-marker">**</div>
            <div className="feature-content">
              <p className="feature-text highlighted">30+ courses + Practical Cleanroom Exposure</p>
              <p className="feature-subtext">** Total duration 160+ hours.</p>
            </div>
          </div>

          <div className="feature-item">
            <div className="feature-marker">**</div>
            <div className="feature-content">
              <p className="feature-text highlighted">BATCH SIZE: 25 – 50 FOR ALL PROGRAMMES</p>
            </div>
          </div>

          <div className="feature-item">
            <div className="feature-marker">**</div>
            <div className="feature-content">
              <p className="feature-text">FULLY CUSTOMIZABLE TO SUIT SPECIFIC CORPORATE REQUIREMENTS</p>
            </div>
          </div>

          <div className="feature-item">
            <div className="feature-marker">**</div>
            <div className="feature-content">
              <p className="feature-text highlighted">ALL PROGRAMMES ARE READY FOR IMMEDIATE START</p>
            </div>
          </div>

          <div className="feature-item">
            <div className="feature-marker">**</div>
            <div className="feature-content">
              <p className="feature-text highlighted">DELIVERY PAN INDIA</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</section>



  

     {/* <!-- Start Testmonial --> */}
     {/* <div class="ak-height-125 ak-height-lg-80"></div> */}
     <section>
        <div class="container">
            <div class="testmonial-top-content">
                <div class="ak-section-heading ak-style-1 animation-title-content animation-style3">
                    {/* <p class="ak-section-subtitle animation-title">Feedback</p> */}
                    <h2 class="ak-section-title animation-title" style={{fontSize:"40px"}}>
                    Step into the Future of Wafer Fabs & OSAT ATMP
                    </h2>
                </div>
                {/* <div class="testmonial-top-desp">
                The semiconductor industry is at the forefront of technological innovation, driving advancements in key areas such as 5G, Artificial Intelligence (AI), Robotics, IoT, Automotive technology, and High-Performance Computing (HPC). Here's an overview of the market's tremendous growth potential:
                </div> */}
            </div>
            {/* <div class="ak-height-60 ak-height-lg-50"></div> */}
            <div class="testmonial-content ak-slider ak-slider-testmonial">
                <div class="swiper-wrapper" style={{marginTop:'20px'}}>
                    <div class="swiper-slide">
                        <div class="testmonial-slider">
                            <div class="testmonial-img">
                                <img src="./assets/img/service/fo.jpeg" data-swiper-parallax="200" alt="..." />
                            </div>
                            <div class="testmonial-info">
                                <p class="testmonial-shot-title">
                                India Semiconductor Mission: Empowering the Industry

                                </p>
                                <div class="ak-height-40 ak-height-lg-30"></div>
                                <h3 class="testmonial-title" style={{fontSize:'23px'}}>
                                <strong>Program Highlights:</strong> <br/> <br/>
      <ul style={{fontSize:'19px',textAlign:'justify',lineHeight: '1.5'}} >
    
     
          <li><strong>Duration & Commitment:</strong> Total Training Duration: 160+ hours. Comprehensive blend of theoretical learning and hands-on practical exposure.</li>
          <li><strong>Batch Size:</strong> Ideal for corporate and group training, with batch sizes ranging from 25 to 50 participants to ensure effective learning and interaction.</li>
          <li><strong>Delivery Locations:</strong> Fully operational for PAN-India delivery, providing convenience and accessibility to participants across the country.</li>
          <li><strong>Customization Options:</strong> Programs can be fully customized to match specific corporate or individual learning objectives, ensuring relevance and immediate applicability in real-world scenarios.</li>
      
      </ul>

                                </h3>
                                <div class="ak-height-50 ak-height-lg-30"></div>
                                {/* <div class="person-info">
                                    <div>
                                        <p class="name">Andrew Taylor</p>
                                        <p class="form">From USA</p>
                                    </div>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="43" height="38" viewBox="0 0 43 38" fill="none">
                        <path
                          d="M19.2291 14.229C19.2291 20.8709 17.6233 26.0703 14.4117 29.8272C11.2 33.5841 6.68822 36.0531 0.876244 37.2343V30.4171C5.28972 29.064 8.25971 26.6176 9.7862 23.078C10.6236 21.3935 10.9863 19.5127 10.8351 17.6376H0.548283L0.548283 0.39867L19.2291 0.39867V14.229ZM42.9883 14.229C42.9883 20.7836 41.4261 25.962 38.3018 29.7642C35.1775 33.5664 30.6221 36.0571 24.6354 37.2363V30.4191C29.0929 29.0193 32.0862 26.6159 33.6154 23.209C34.3942 21.4604 34.7318 19.5472 34.5983 17.6376L24.3075 17.6376V0.39867H42.9883L42.9883 14.229Z"
                          fill="#485B60"
                        />
                      </svg>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    {/* <div class="swiper-slide">
                        <div class="testmonial-slider">
                            <div class="testmonial-img">
                                <img src="./assets/img/bg/bg6.png" data-swiper-parallax="200" alt="..." />
                            </div>
                            <div class="testmonial-info">
                                <p class="testmonial-shot-title">
                                Growing Demand and Key Industry Players
                                </p>
                                <div class="ak-height-40 ak-height-lg-30"></div>
                                <h4 class="testmonial-title" style={{fontSize:'28px'}}>
                              <strong>Additional Features:</strong>
      <ul>
        <li>Orientation visit to a Fab Cleanroom</li>
        <li>Includes industry relevant videos</li>
        <li>Delivery Mode: Face-to-Face</li>
      </ul>
   
                                </h4>
                                <div class="ak-height-50 ak-height-lg-30"></div>
                               
                            </div>
                        </div>
                    </div> */}
                </div>
                <div class="testmonial-controller">
                    {/* <div class="testmonial-swiper-controller">
                        <button class="testmonial-next-btn slider-btn next">
                <svg
                  width="10"
                  height="18"
                  viewBox="0 0 10 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.00928 0.73999L1.00928 8.73999L9.00928 16.74"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
                        <button class="testmonial-prev-btn slider-btn prev">
                <svg
                  width="10"
                  height="18"
                  viewBox="0 0 10 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.00928 0.73999L9.00928 8.73999L1.00928 16.74"
                    stroke="#030917"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
                    </div> */}
                    {/* <div>
                        <p class="ak-black-color mb-0 ak-medium">350+ Over</p>
                        <p class="ak-font-16 mb-0">User Feedback</p>
                    </div> */}
                </div>
            </div>
        </div>
    </section>
    {/* <!-- End Testmonial --> */}


     {/* <!-- Start Feature --> */}
     {/* <div class="ak-height-100 ak-height-lg-50"></div> */}
     <h3 class="ak-section-title animation-title" style={{fontSize:'35px',textAlign:'center',marginTop:'10px'}}>
     Comprehensive training program to prepare you for a successful career in semiconductor fabrication
                </h3>
                {/* <h2  style={{fontSize:'15px',marginTop:'20px' ,textAlign:'center'}}>
                This program equips candidates with advanced skills in DFT and analog circuit design, offering an industry-aligned curriculum, hands-on training, and certifications. Graduates are prepared for key roles like Wafer Fab Process Engineer, Quality Engineer, and more in the IC design and manufacturing industry
                    </h2> */}
    <section class="container">
        <div class="feature-content gap-2" style={{marginTop:'10px'}}>
            <div class="feature-card">
                <img class="feature-icon" src="./assets/img/icon/ok-sign.svg" alt="..." />
                <div class="feature-body">
                    <h5 class="feature-title">Prerequisites</h5>
                   
                    <p style={{textAlign:'justify'}}>This program covers common skills in semiconductor and fab manufacturing but emphasizes advanced topics such as wafer processing, OSAT testing, and packaging. Ideal candidates should have a background in Engineering or Science in fields such as:</p>
    
    
 
  <ul>
    <li>Electronics</li>
    <li>Electrical</li>
    <li>Mechanical</li>
    <li>Chemical Engineering</li>
    <li>Physics, or Material Science</li>
   
  </ul>

                </div>
            </div>
            <div class="ak-feature-hr ak-h-100"></div>
            <div class="feature-card">
                <img class="feature-icon" src="assets/img/icon/ok-sign.svg" alt="..." />
                <div class="feature-body">
                    <h5 class="feature-title">Program Benefits</h5>
                    <p style={{textAlign:'justify'}}>While standard campus programs may not cover niche industry-specific skills, this program extends training to critical areas such as wafer fab processes, OSAT assembly, and testing. Participants will benefit from:</p>
  <ul>
    {/* <li>Industry-aligned curriculum</li> */}
    <li>Hands-on training with cutting-edge semiconductor equipment and processes</li>
          <li>Focus on current wafer manufacturing technologies and OSAT integration</li>
          <li>Quality management and process control expertise</li>
          {/* <li>Development of career-ready skills tailored for semiconductor industry roles</li> */}
          {/* <li>Certification recognized by industry leaders</li> */}
      
  </ul>
                </div>
            </div>
            <div class="ak-feature-hr ak-h-100"></div>
            <div class="feature-card">
                <img class="feature-icon" src="assets/img/icon/ok-sign.svg" alt="..." />
                <div class="feature-body">
                    <h5 class="feature-title">Career Opportunities
                    </h5>
                    <p style={{textAlign:'justify'}}>This program provides participants with practical skills from industry experts, preparing them for high-demand roles in semiconductor manufacturing and OSAT finishing. Graduates will be qualified for positions such as:</p>
  <ul>
  <li>Wafer Fab Process Engineer</li>
          <li>Quality Control Engineer</li>
          <li>Semiconductor Equipment Engineer</li>
          <li>Process Integration Engineer</li>
          {/* <li>Yield Enhancement Engineer</li> */}
          <li>OSAT Packaging and Testing Engineer</li>
    {/* <li>Failure Analysis Engineer</li> */}
  </ul>
                </div>
            </div>
        </div>
    </section>

    {/* <!-- Start Accordion --> */}
    <div class="ak-height-50 ak-height-lg-50"></div>
    <section>
        <div class="container">
            <div class="row align-items-center">
                <div class="col-xl-6 col-12 d-none d-xl-block">
                    <div class="image-hov-one">
                        <img src="./assets/img/service/sb2.png" class="img-fluid" alt="..." />
                    </div>
                </div>
                <div class="col-xl-6 col-12"  >
                    <div class="ak-accordion">
                        <div class="ak-accordion-item">
                            <div class="ak-accordion-title-content active">
                                <h6 class="ak-accordion-title">
                                What will I learn in Wafer Fab Training?
                                </h6>
                                <span class="accordion-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="11"
                      viewBox="0 0 16 11"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_347_32rtyr)">
                        <path
                          d="M8.00033 1.10913C7.82983 1.10913 7.65916 1.1743 7.529 1.30446L0.862366 7.9711C0.601868 8.23159 0.601868 8.65342 0.862366 8.91376C1.12286 9.17409 1.5447 9.17426 1.80503 8.91376L8.00033 2.71846L14.1956 8.91376C14.4561 9.17426 14.878 9.17426 15.1383 8.91376C15.3986 8.65326 15.3988 8.23143 15.1383 7.9711L8.47166 1.30446C8.34149 1.1743 8.17083 1.10913 8.00033 1.10913Z"
                          fill="#030917"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_347_32rtyr">
                          <rect
                            width="16"
                            height="10"
                            fill="white"
                            transform="translate(0.000488281 0.109131)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                            </div>
                            <div class="ak-accordion-tab">
                            <p style={{textAlign:'justify'}}>In Wafer Fab training, you will learn advanced processing techniques, cleanroom management, safety protocols, and equipment handling and inspection essential for wafer fabrication.</p>
                            </div>
                        </div>
                        <div class="ak-accordion-item">
                            <div class="ak-accordion-title-content">
                                <h6 class="ak-accordion-title">
                                What does OSAT Process Training cover?
                                </h6>
                                <span class="accordion-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="11"
                      viewBox="0 0 16 11"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_347_324353)">
                        <path
                          d="M8.00033 1.10913C7.82983 1.10913 7.65916 1.1743 7.529 1.30446L0.862366 7.9711C0.601868 8.23159 0.601868 8.65342 0.862366 8.91376C1.12286 9.17409 1.5447 9.17426 1.80503 8.91376L8.00033 2.71846L14.1956 8.91376C14.4561 9.17426 14.878 9.17426 15.1383 8.91376C15.3986 8.65326 15.3988 8.23143 15.1383 7.9711L8.47166 1.30446C8.34149 1.1743 8.17083 1.10913 8.00033 1.10913Z"
                          fill="#030917"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_347_324353">
                          <rect
                            width="16"
                            height="10"
                            fill="white"
                            transform="translate(0.000488281 0.109131)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                            </div>
                            <div class="ak-accordion-tab">
                            <p style={{textAlign:'justify'}}>OSAT Process training covers semiconductor assembly techniques like die attach, wire bonding, and encapsulation. You will also gain knowledge of testing and quality assurance processes, as well as the industry standards for packaging and delivery.</p>
                            </div>
                        </div>
                        <div class="ak-accordion-item">
                            <div class="ak-accordion-title-content">
                                <h6 class="ak-accordion-title">
                                What practical skills will I develop?
                                </h6>
                                <span class="accordion-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="11"
                      viewBox="0 0 16 11"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_347_32ewrwe)">
                        <path
                          d="M8.00033 1.10913C7.82983 1.10913 7.65916 1.1743 7.529 1.30446L0.862366 7.9711C0.601868 8.23159 0.601868 8.65342 0.862366 8.91376C1.12286 9.17409 1.5447 9.17426 1.80503 8.91376L8.00033 2.71846L14.1956 8.91376C14.4561 9.17426 14.878 9.17426 15.1383 8.91376C15.3986 8.65326 15.3988 8.23143 15.1383 7.9711L8.47166 1.30446C8.34149 1.1743 8.17083 1.10913 8.00033 1.10913Z"
                          fill="#030917"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_347_32ewrwe">
                          <rect
                            width="16"
                            height="10"
                            fill="white"
                            transform="translate(0.000488281 0.109131)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                            </div>
                            <div class="ak-accordion-tab">
                            <p style={{textAlign:'justify'}}>You will gain hands-on exposure to state-of-the-art cleanroom facilities and learn to apply theoretical knowledge in real-life manufacturing processes. Additionally, you'll develop an understanding of KPIs for yield, cycle time, and quality.</p>
                            </div>
                        </div>
                        <div class="ak-accordion-item">
                            <div class="ak-accordion-title-content">
                                <h6 class="ak-accordion-title">
                                Why should I choose your Finishing School?
                                </h6>
                                <span class="accordion-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="11"
                      viewBox="0 0 16 11"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_347_3243fgdg)">
                        <path
                          d="M8.00033 1.10913C7.82983 1.10913 7.65916 1.1743 7.529 1.30446L0.862366 7.9711C0.601868 8.23159 0.601868 8.65342 0.862366 8.91376C1.12286 9.17409 1.5447 9.17426 1.80503 8.91376L8.00033 2.71846L14.1956 8.91376C14.4561 9.17426 14.878 9.17426 15.1383 8.91376C15.3986 8.65326 15.3988 8.23143 15.1383 7.9711L8.47166 1.30446C8.34149 1.1743 8.17083 1.10913 8.00033 1.10913Z"
                          fill="#030917"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_347_3243fgdg">
                          <rect
                            width="16"
                            height="10"
                            fill="white"
                            transform="translate(0.000488281 0.109131)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                            </div>
                            <div class="ak-accordion-tab">
                            <ul style={{textAlign:'justify'}}>
        <li><strong>Industry-Relevant Curriculum:</strong> Over 30+ specialized courses covering critical aspects of wafer fabrication and OSAT processes.</li>
        <li><strong>Hands-On Cleanroom Exposure:</strong> Real-world experience in cleanroom environments, preparing you for professional settings.</li>
        <li><strong>Flexible & Customizable Programs:</strong> Tailored programs to meet specific corporate requirements and upskill teams effectively.</li>
        <li><strong>Immediate Start:</strong> Programs are ready for launch, ensuring quick and easy initiation of training for individuals and organizations.</li>
      </ul>
                            </div>
                        </div>
                        <div class="ak-accordion-item">
                            <div class="ak-accordion-title-content">
                                <h6 class="ak-accordion-title">
                                What industries benefit from this training?
                                </h6>
                                <span class="accordion-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="11"
                      viewBox="0 0 16 11"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_347_32345fds)">
                        <path
                          d="M8.00033 1.10913C7.82983 1.10913 7.65916 1.1743 7.529 1.30446L0.862366 7.9711C0.601868 8.23159 0.601868 8.65342 0.862366 8.91376C1.12286 9.17409 1.5447 9.17426 1.80503 8.91376L8.00033 2.71846L14.1956 8.91376C14.4561 9.17426 14.878 9.17426 15.1383 8.91376C15.3986 8.65326 15.3988 8.23143 15.1383 7.9711L8.47166 1.30446C8.34149 1.1743 8.17083 1.10913 8.00033 1.10913Z"
                          fill="#030917"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_347_32345fds">
                          <rect
                            width="16"
                            height="10"
                            fill="white"
                            transform="translate(0.000488281 0.109131)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                            </div>
                            <div class="ak-accordion-tab">
                            <p style={{textAlign:'justify'}}>Industries involved in semiconductor manufacturing, electronics, and precision engineering will benefit the most from this training. This includes companies that specialize in wafer fabrication, OSAT, and the assembly and testing of semiconductor components.</p>
                            </div>
                        </div>
                        <div class="ak-accordion-item">
                            <div class="ak-accordion-title-content">
                                <h6 class="ak-accordion-title">
                                Can the training program be delivered onsite for my team?
                                </h6>
                                <span class="accordion-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="11"
                      viewBox="0 0 16 11"
                      fill="none"
                    >
                      <g clip-path="url(#clip0_347_3243gfd)">
                        <path
                          d="M8.00033 1.10913C7.82983 1.10913 7.65916 1.1743 7.529 1.30446L0.862366 7.9711C0.601868 8.23159 0.601868 8.65342 0.862366 8.91376C1.12286 9.17409 1.5447 9.17426 1.80503 8.91376L8.00033 2.71846L14.1956 8.91376C14.4561 9.17426 14.878 9.17426 15.1383 8.91376C15.3986 8.65326 15.3988 8.23143 15.1383 7.9711L8.47166 1.30446C8.34149 1.1743 8.17083 1.10913 8.00033 1.10913Z"
                          fill="#030917"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_347_3243gfd">
                          <rect
                            width="16"
                            height="10"
                            fill="white"
                            transform="translate(0.000488281 0.109131)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </span>
                            </div>
                            <div class="ak-accordion-tab">
                            <p style={{textAlign:'justify'}}>Yes, we offer customized onsite training programs for corporate teams. Our expert trainers can come to your location to deliver training, ensuring it aligns with your team's specific needs and schedules.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <div class="ak-height-75 ak-height-lg-50"></div> */}
            {/* <div class="d-flex">
                <p class="ak-font-50 ak-medium ak-black-color ak-line-height-100 me-2">
                    F
                </p>
                <p class="">
                    It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here,
                    content here', making it look like readable English. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has.
                </p>
            </div> */}
            {/* <div class="ak-height-20 ak-height-lg-20"></div> */}
            {/* <p>
                It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here,
                content here', making it look like readable English. It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less
                normal distribution.
            </p> */}

            {/* <div class="ak-height-50 ak-height-lg-30"></div> */}
            {/* <div class="image-hov-one">
                <img src="assets/img/service/service_detail_3.png" class="img-fluid" alt="..." />
            </div> */}
            <div class="ak-height-50 ak-height-lg-30"></div>
            {/* <!-- Start Previous and next btn --> */}
            {/* <div class="d-flex flex-lg-nowrap flex-wrap justify-content-between align-items-center gap-lg-5 gap-2">
                <a href="#" class="more-btn arrow-left-style">
            <span class="svg-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="15"
                viewBox="0 0 14 15"
                fill="none"
              >
                <path
                  d="M12.5869 7.14932H0.920246M0.920246 7.14932L6.52025 1.54932M0.920246 7.14932L6.52025 12.7493"
                  stroke="#030917"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="15"
                viewBox="0 0 14 15"
                fill="none"
              >
                <path
                  d="M12.5869 7.14932H0.920246M0.920246 7.14932L6.52025 1.54932M0.920246 7.14932L6.52025 12.7493"
                  stroke="#030917"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <span class="ak-body-color ak-black-color-hover"
              >Previous Case Study</span
            >
          </a>
                <span class="ak-border-width color-black d-none d-lg-inline"></span>
                <a href="#" class="more-btn">
            <span class="ak-body-color ak-black-color-hover"
              >Next Case Study</span
            >
            <span class="svg-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="15"
                viewBox="0 0 14 15"
                fill="none"
              >
                <path
                  d="M1.41309 7.14932H13.0798M13.0798 7.14932L7.47975 1.54932M13.0798 7.14932L7.47975 12.7493"
                  stroke="#030917"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="15"
                viewBox="0 0 14 15"
                fill="none"
              >
                <path
                  d="M1.41309 7.14932H13.0798M13.0798 7.14932L7.47975 1.54932M13.0798 7.14932L7.47975 12.7493"
                  stroke="#030917"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
          </a>
            </div> */}
            {/* <!-- End Previous and next btn --> */}
        </div>
    </section>
    {/* <!-- End Accordion --> */}
    <span class="ak-scrollup">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 10L1.7625 11.7625L8.75 4.7875V20H11.25V4.7875L18.225 11.775L20 10L10 0L0 10Z"
          fill="currentColor"
        />
      </svg>
    </span>
    </div>
  )
}

export default Febosat
